import { Grid, withWidth} from "@material-ui/core";
import React, { useEffect } from "react";
import { Text, Stack} from 'office-ui-fabric-react';
import LoginRedirectBg from "../../../../../assert/images/login_bg.webp";
//import { PrimaryButton } from "@fluentui/react";
import Logo from "../../../../../assert/images/MxLearn-Logo.png";
//import OverViewBg from "../../../../assert/images/overviewbg.png";
import loader from "../../../../../assert/images/loader.png";

function LoginRedirect(props) {
    let [height, setHeight] = React.useState(window.innerHeight);
    let [width, setWidth] = React.useState(window.innerWidth);
    const [rotation, setRotation] = React.useState(0);

    let updateWidthAndHeight = () => {
        setHeight(window.innerHeight);
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener("resize", updateWidthAndHeight);
        return () => window.removeEventListener("resize", updateWidthAndHeight);
    });

    function getLoading() {
        if (rotation >= 360) {
            setRotation(0);
        } else {
            setRotation(rotation + 5);
        }
    }

    useEffect(() => {
        if (props.signInClick) {
            let load = setInterval(() => {
                getLoading();
                clearInterval(load);
            }, 10);
        }
    }, [rotation]);
 
    return (
        <React.Fragment>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                style={{
                    height: height,
                    backgroundColor: "#4A3CF2",
/*                    backgroundImage: `url(${OverViewBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'bottom left',*/
                }}
            >
                <div style={{ width: "100%", height: "100%", position: "relative" }}>
                    <div style={{
                        display: "inline-block",
                        position: "absolute",
                        bottom: "10%",
                        left: 0,
                        margin: "0 auto"
                    }}>
                {
                    [...Array(4)].map((_, j) => {
                        let data = [...Array(10)].map((_, i) => {
                            return (<span key={i} style={{
                                margin: 20,
                                height: 20,
                                width: 20,
                                backgroundColor: "#5e5ee6",
                                borderRadius: "50%",
                                display: "inline-block",
                            }}></span>)
                        });
                        return (<div key={j}>{data}</div>)
                    })
                        }
                    </div>
                    </div>
               {/* <div style={{ width: "100%", height: "100%", position: "relative"}}>
                    <img src={OverViewBg} width="40%" height="30%" style={{
                        display: "inline-block",
                        position: "absolute",
                        bottom: "10%",
                        left: 0,
                        margin: "0 auto"}}/>
                    </div>*/}
                <Grid item xs={12} sm={6} style={{ flex: 1, width: width / 2, height: height / 2, position: "absolute",}}>
                    <div style={{ width: "100%", height: "100%", backgroundImage: `url(${LoginRedirectBg})`, backgroundPosition: 'center', backgroundSize: 'cover'}}>
                       
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            style={{ width: "100%", height: "100%", }}
                           
                        >

                            <Grid item xs={12} sm={6} style={{ textAlign: "center", paddingLeft: 40 }}>
                                <Stack vertical >                                    
                                    <Stack.Item ><img src={Logo} alt={"LOGO"} width={"55%"}/></Stack.Item><br/>
                                    <Stack.Item><Text style={{ color: "#000", fontSize: 12 }}>Welcome Back</Text></Stack.Item><br/>
                                    <Stack.Item><Text style={{ color: "#000", fontSize: 12 }}>We are signing you in…</Text></Stack.Item>
                                    
                                    <Stack.Item align="center" style={{ paddingTop: 30, color: "#fff" }}>
                                        <img style={{ transform: `rotate(${rotation}deg)` }} src={loader} width="60%" height="60%" />
                                        {/*<PrimaryButton
                                            style={{ backgroundColor: "#000", border: "1px solid black", borderRadius: 5 }}
                                            text={<Stack horizontal> <Icon iconName="Lock" style={{paddingRight: 5}} /> Sign In </Stack>}
                                            onClick={() => { props.onSignIn(); }}
                                            allowDisabledFocus
                                    />*/}

                                    </Stack.Item>
                                </Stack>
                            </Grid>
                            <Grid item xs={6}/>
                            {/*<Text onClick={() => {props.setSignInClick(false); }} style={{ cursor:"pointer", color: "#fff", width: "100%", paddingTop: 20, fontSize: 14, textAlign: "center" }}>Back to <span style={{ color: "#14E2C5" }}>Home</span></Text>*/}
                        </Grid>
                    </div>
                    
                </Grid>
            </Grid>

        </React.Fragment>
    );
}

export default withWidth()(LoginRedirect);